import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-responding',
  templateUrl: './not-responding.component.html',
  styleUrls: ['./not-responding.component.css']
})
export class NotRespondingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
